<template>
  <QS-common-table
    :ref="attrs.ref||'blmCommonTable'"
    class="mt16"
    v-bind="attrs"
    v-on="events"
    :highlight-current-row="highlightCurrentRow"
    :show-header="showHeader"
    :loading="loading"
    :data="list"
    :columns="columns"
    :pagination="pagination"
    @change="(e)=>paginationChange(e,true)"
    v-if="isShowTable"
  >
    <template slot="operation-group">
      <slot name="operation-group" />
    </template>
    <template slot="tools">
      <slot name="tools" />
    </template>
    <template slot="col-name-header">
      <slot name="col-name-heade" />
    </template>
    <template slot="col-name">
      <slot name="col-name" />
    </template>
    <!-- 线索id支持展示标签+id -->
    <template slot="col-id" slot-scope="item">
      <div class="col-id">
        {{ item.row.id }}
        <!-- 线索标签 -->
        <el-tooltip
          effect="dark"
          content="线索创建后48小时内未进行跟进操作记录系统将被回收，请及时跟进。"
          placement="bottom-start"
        >
          <el-tag
            v-if="item && item.row.platformTag"
            size="medium"
            type="danger"
          >
            {{ item.row.platformTag }}
          </el-tag>
        </el-tooltip>
      </div>
    </template>
    <template slot="col-label" slot-scope="item">
      <LeadTag
        v-if="item && item.row && item.row.label"
        :tags='item.row.label'
        :showPopover='item.row.label && item.row.label.length>2'
      />
    </template>
  </QS-common-table>
</template>
<script>
import LeadTag from '@/pages/orders/salesLeadManagement/components/leadTag.vue'
import mixin from './mixins'

export default {
  name: 'BaseTable',
  components: {
    LeadTag,
  },
  mixins: [mixin],
}
</script>
<style lang="scss" scoped>
.col-label {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: -10px 0px 0px -10px;
  .el-tag{
    margin: 10px 0px 0px 10px;
  }
}
</style>
